$(document).ready(function () {
	posts.shift();

	//infinite scroll
	let page = 4,
		itemsPerPage = 3;

	$('.js-load-more').on('click', function () {
		loadPosts();
	});

	$(window).on('scroll', function () {
		let windowTop = $(window).scrollTop();

		if ($('.js-load-more').offset().top < windowTop + window.innerHeight) {
			loadPosts();
		}
	});

	function loadPosts() {
		let articlesContainer = $('.p-articles-main__items');

		$.each(posts, function (index, item) {
			let post = $(
				'<div class="p-articles-main__item"><a class="c-card" href="' +
					item['url'] +
					'"><div class="c-card__inner"><div class="c-card__image"><img class="c-card__image-src" src="' +
					item['thumbnail_url'] +
					'" alt="' +
					item['post_title'] +
					'"></div><div class="c-card__content"><span class="c-card__date">' +
					item['time'] +
					'</span><h2 class="c-card__title">' +
					item['post_title'] +
					'</h2><p class="c-card__excerpt">' +
					item['description'] +
					'</p><span class="c-card__category">Webinars</span></div></div></a></div>'
			);
			let postYear = new Date(item['time']).getFullYear();
			startItem = page * itemsPerPage;
			endItem = startItem + itemsPerPage;

			if (index >= startItem && index < endItem) {
				articlesContainer.append(post);
			}
		});

		page++;

		maxPages = Math.ceil(posts.length / itemsPerPage);

		if (page >= maxPages) {
			$('.js-load-more').hide();
		}
	}
});
